var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.98 160.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#71777e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.98,160.38h-1.57l-2.92-7.65-2.92,7.65H0l3.55-9.18h1.89l3.55,9.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.98,149.58h-1.57l-2.92-7.65-2.92,7.65H0l3.55-9.18h1.89l3.55,9.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.98,138.78h-1.57l-2.92-7.65-2.92,7.65H0l3.55-9.18h1.89l3.55,9.18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.98,127.98h-1.57l-2.92-7.65-2.92,7.65H0l3.55-9.18h1.89l3.55,9.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.98,117.18h-1.57l-2.92-7.65-2.92,7.65H0l3.55-9.18h1.89l3.55,9.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,104.24h-1.67v-4.55h1.67v4.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,93.44h-1.67v-4.55h1.67v4.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,82.64h-1.67v-4.55h1.67v4.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,71.84h-1.67v-4.55h1.67v4.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,61.04h-1.67v-4.55h1.67v4.55Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,50.24h-1.67v-4.55h1.67v4.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,39.44h-1.67v-4.55h1.67v4.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,28.64h-1.67v-4.55h1.67v4.55Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.04,17.84h-1.67v-4.55h1.67v4.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.98,9.18h-1.57L4.5,1.53l-2.92,7.65H0L3.55,0h1.89l3.55,9.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSeperator);
export default __webpack_public_path__ + "static/media/arrow-seperator.c02337f750e70915853f0a667a3d7ac2.svg";
export { ForwardRef as ReactComponent };